import { Box, Flex, Text } from '@chakra-ui/react';
import NextImage from 'next/image';

import { Section } from '$components/layout/section';
import { FadeIn } from '$components/ui/fade-in';
import { Markdown } from '$components/ui/markdown';
import { bioParagraphs } from '$shared/bio';

const AVATAR_URL = 'https://github.com/SilvanoGPM.png';

interface AboutMeProps {
  /** Markdown content vindo do DatoCMS `info.aboutMe`. */
  content?: string;
}

export function AboutMe({ content }: AboutMeProps) {
  const hasContent = content && content.trim().length > 0;

  return (
    <Section dataScroll="about" eyebrow="Sobre" title="Olá.">
      <Flex
        direction={{ base: 'column', md: 'row' }}
        gap={{ base: '32px', md: '56px' }}
        align="start"
      >
        <FadeIn flexShrink={0}>
          <Box
            pos="relative"
            w={{ base: '180px', md: '220px' }}
            h={{ base: '180px', md: '220px' }}
          >
            <Box
              pos="absolute"
              inset="0"
              transform="translate(14px, 14px)"
              bg="accent.dim"
              className="blob-morph"
              sx={{
                borderRadius: '52% 48% 62% 38% / 48% 56% 44% 52%',
              }}
            />

            <Box
              pos="relative"
              w="full"
              h="full"
              overflow="hidden"
              className="blob-morph"
              bg="bg.surface"
              borderWidth="1px"
              borderColor="line.subtle"
              sx={{
                borderRadius: '52% 48% 62% 38% / 48% 56% 44% 52%',
              }}
            >
              <NextImage
                src={AVATAR_URL}
                alt="Silvano Marques"
                fill
                sizes="220px"
                style={{ objectFit: 'cover' }}
                priority
              />
            </Box>
          </Box>
        </FadeIn>

        <Box flex="1" maxW="60ch">
          {hasContent ? (
            <Markdown>{content!}</Markdown>
          ) : (
            bioParagraphs.map((paragraph, index) => (
              <Text
                key={index}
                fontSize={{ base: '17px', md: '18px' }}
                lineHeight="1.7"
                color="text.muted"
                mb="20px"
              >
                {paragraph}
              </Text>
            ))
          )}
        </Box>
      </Flex>
    </Section>
  );
}
